/***************************************************************************************************
** compactify
***************************************************************************************************/

import isObject from "@utils/helpers/object/isObject";

export default function compactify(data) {
  if (!isObject(data)) return data;

  return Object.entries(data).reduce((obj, [name, value]) => {
    if (value) obj[name] = compactify(value);
    return obj;
  }, {});
}
